import React, { useState, useEffect } from "react";
import {
  Notifications,
  Place,
  Phone,
  AirlineSeatIndividualSuite,
} from "@mui/icons-material";
import apilink from "../globals/Baseurls";
import axios from "axios";

const AdminHome = () => {
  const [family, setFamily] = useState("");
  const [familycode, setFamilycode] = useState("");
  const [hasMember, setHasMember] = useState("");

  const [familylevels, setFamilylevels] = useState(1);
  const [members, setMembers] = React.useState([]);
  const [filtered, setFiltered] = React.useState([]);
  const [onfilter, setOnfilter] = useState(false);

  const filterArray = async (lvl, id) => {
    let tempArr = [];
    let objIndex = null;

    if (onfilter) {
      tempArr = filtered.filter(
        (item) => !(item.level === lvl && item.id !== id)
      );
      tempArr = tempArr.filter(
        (item) => !(item.level === lvl + 1 && item.parent !== id)
      );
      objIndex = tempArr.findIndex((obj) => obj.id == id);
    } else {
      tempArr = members.filter(
        (item) => !(item.level === lvl && item.id !== id)
      );
      tempArr = tempArr.filter(
        (item) => !(item.level === lvl + 1 && item.parent !== id)
      );
      objIndex = tempArr.findIndex((obj) => obj.id == id);
    }

    tempArr[objIndex].showkids = true;
    setFiltered(tempArr);
    setOnfilter(true);
   
  };

  const resetFiltering = () => {
    setFiltered(members);
    setOnfilter(false);
  
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const storedUser = await JSON.parse(
        localStorage.getItem("userSessionData")
      );
      setFamily(storedUser.family);
      setFamilycode(storedUser.familycode);
      setHasMember(storedUser.hasmember);
      setFamilylevels(storedUser.familylevel);

      //Get members from API

      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          //console.log("Message" + response.data.records[0]);
          if (response.data.message == "Successfull") {
            setMembers(response.data.records);
            setFiltered(response.data.records);
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);

  const levelViews = [];

  for (let i = 1; i <= familylevels; i++) {
    const filteredMembers = filtered.filter((item) => item.level === i);

    levelViews.push(
      <div
        key={i}
        style={{
          flexDirection: "row",
          justifyContent: "flex-start",
          marginBottom: 10,
          paddingBottom: 20,
          paddingTop: 20,
          gap: "20px",
          overflowX: "scroll",
          whiteSpace: "nowrap" /* Optional: prevents content from wrapping */,
          display: "flex" /* Optional: for arranging items horizontally */,
          width: "100%" /* Or a fixed width */,
        }}
      >
        {filteredMembers.map((item) => (
          <div
            key={item.id}
            onClick={() => filterArray(item.level, item.id)}
            style={{
              width: 180,
              height: 350,
              border: "2px solid #a9d5a9",
              borderRadius: 6,
              display: "flex",
              flexDirection: "column",
              padding: 8,
              whiteSpace: "normal",
            }}
          >
            <img
              alt="logo"
              style={{
                width: "164px",
                height: "130px",
                resizeMode: "stretch",
                borderRadius: 6,
                marginBottom: 6,
              }}
              src={
                item.img == null
                  ? `https://treebackend.globalsparks.live/tree-backend/public/images/members/temp1.png`
                  : `https://treebackend.globalsparks.live/tree-backend/public/images/members/${item.img}`
              }
            />
            <h6
              style={{
                marginTop: -19,
                color: "#779d38",
                alignSelf: "flex-end",
                marginRight: 1,
                backgroundColor: "white",
                padding: 9,
                borderRadius: 10,
              }}
            >
              {item.born}
            </h6>
            <div
              style={{
                height: 40,
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <h6>
                {item.alias} {item.surname}
              </h6>
            </div>
            <div
              style={{
                height: 20,
              }}
            >
              <label style={{ fontSize: "11px", color: "gray" }}>
                {item.nickname}
              </label>
            </div>

            <div
              style={{
                height: 40,
              }}
            >
              {item.parentname !== null && (
                <>
                  {item.gender == "Male" && (
                    <>
                      <label
                        style={{
                          fontSize: 11,
                          marginTop: 5,
                        }}
                      >
                        Son Of: {item.parentname}
                      </label>
                    </>
                  )}
                  {item.gender == "Female" && (
                    <>
                      <label
                        style={{
                          fontSize: 11,
                          marginTop: 5,
                        }}
                      >
                        Daughter Of: {item.parentname}
                      </label>
                    </>
                  )}
                </>
              )}
            </div>

            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: 10,
                height: 30,
              }}
            >
              <Place style={{ color: "#a9d5a9", fontSize: 30 }} />
              <label
                style={{
                  fontSize: 11,
                  marginTop: 5,
                }}
              >
                {item.residance}
              </label>
            </div>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: 10,
                height: 30,
              }}
            >
              <Phone style={{ color: "#a9d5a9", fontSize: 30 }} />
              <label
                style={{
                  fontSize: 11,
                  marginTop: 5,
                }}
              >
                {item.phone == null || item.phone == ""
                  ? "- - - - - - - - - -"
                  : item.phone}
              </label>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <div>
                {item.diedon != null && (
                  <>
                    <AirlineSeatIndividualSuite
                      style={{ color: "#a9d5a9", fontSize: 30 }}
                    />
                    <label
                      style={{
                        fontSize: 11,
                        marginTop: 5,
                      }}
                    >
                      &nbsp;{item.diedon}
                    </label>
                  </>
                )}
              </div>
              {item.showkids && onfilter && (
                <img
                  alt="logo"
                  style={{
                    width: "30px",
                    height: "30px",
                    resizeMode: "stretch",
                  }}
                  src={require("./arrow.webp")}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h4 style={{ color: "#779d38" }}>
          {family} Family ({familycode})
        </h4>

        <span style={{ fontFamily: "Open Sans" }}>
          <Notifications style={{ color: "#000000", fontSize: 30 }} />{" "}
          <p
            style={{
              padding: "2px",
              backgroundColor: "red",
              marginTop: "-15px",
              borderRadius: "10px",
              width: "12px",
              height: "12px",
              position: "absolute",
              marginLeft: "20px",
            }}
          ></p>
        </span>
      </div>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {hasMember !== "No" && (
          <>
            <button
              onClick={() => resetFiltering()}
              style={
                onfilter
                  ? { backgroundColor: "green", borderRadius: 4, width: "180px" }
                  : { backgroundColor: "gray", borderRadius: 4, width: "180px" }
              }
              type="button"
            >
              Reset
            </button>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 100,
              }}
            >
              {levelViews}
            </div>
          </>
        )}
      </div>
      {hasMember == "No" && (
        <>
          <div
            className="alert alert-success row m-1"
            role="alert"
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div className="col-lg-2">
              <img
                alt="logo"
                style={{
                  width: "210px",
                  height: "180px",
                  resizeMode: "stretch",
                  borderRadius: "10px",
                }}
                src={require("./welll.gif")}
              />{" "}
            </div>
            <div className="col-lg-10">
              <p>
                We are glad you are here with us. First you need to register the
                root member who will be on top of family tree. The root person
                or member is the first ancestor or person that your tree will
                start with.
              </p>
              <p>
                To register the new root member of the tree, follow these steps:
                <br />
                <br />
                1. Click on the bottom tab navigation icon labelled{" "}
                <b>Members</b>, it is next to <b>Home</b> icon
                <br />
                2. Click on <b>Add New</b> button
                <br />
                3. Fill in all the required information, captions labelled with
                star means the field is compulsory
                <br />
                3. After completing the form, click on <b>
                  Add New Member
                </b>{" "}
                button and the root member will be saved
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminHome;
